import { Actions } from '@ngrx/effects';
import { BaseResourceEffects } from '../base-resource.effects';
import { pushNotificationTokenActions } from './push-notification-token.actions';
import { PushNotificationTokenService } from '../../services/push-notification-token.service';
import { CoreAppState } from '../core-app.state';
import { Injectable } from '@angular/core';
import { selectPushNotificationTokenState } from './push-notification-token.reducer';
import { Store } from '@ngrx/store';
import { PushNotificationTokenResourceTypeMappings } from '@aa/nest/resource';

@Injectable()
export class PushNotificationTokenEffects extends BaseResourceEffects<PushNotificationTokenResourceTypeMappings> {
  constructor(
    protected override readonly actions$: Actions,
    protected override readonly store: Store<CoreAppState>,
    protected override readonly service: PushNotificationTokenService,
  ) {
    super(
      actions$,
      store,
      service,
      pushNotificationTokenActions,
      selectPushNotificationTokenState,
    );
  }
}
